/** A plan as `GET /api/portal/plans` returns it. Prices are whole so'm. */
export interface PortalPlan {
  key: string;
  name: string;
  subtitle: string;
  monthlyPrice: number;
  dailyPrice: number;
  discountPrice: number;
  mockLimit?: number;
  /** IELTS/SAT attempts whose full analysis the plan unlocks per period. */
  analysisLimit?: number;
  hasAnswerAnalysis?: boolean;
  hasStudyPlan?: boolean;
  hasTeacherConsultation?: boolean;
  hasPersonalAnalytics?: boolean;
  isRecommended?: boolean;
  sortOrder?: number;
}

export interface PlanOffer {
  plan: PortalPlan;
  /** The saving as the checkout will charge it: list price minus `discountPrice`. */
  saving: number;
  percentOff: number;
}

const isWholeSom = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value > 0;

/**
 * The plan to promote once a test is over: the one the catalogue recommends, with the discount the
 * checkout really applies. Anything that cannot be charged safely, or is not actually cheaper, is
 * not offered, so the dialog never shows a price the server would not honour.
 */
export function pickOfferPlan(plans: readonly PortalPlan[] | undefined): PlanOffer | null {
  for (const plan of plans ?? []) {
    if (!plan.isRecommended) continue;
    if (!isWholeSom(plan.monthlyPrice) || !isWholeSom(plan.discountPrice)) continue;
    if (plan.discountPrice >= plan.monthlyPrice) continue;

    const saving = plan.monthlyPrice - plan.discountPrice;
    return { plan, saving, percentOff: Math.round((saving / plan.monthlyPrice) * 100) };
  }
  return null;
}
